<!-- @format -->

<fudis-dialog [size]="'sm'">
  <fudis-heading [level]="2" fudisDialogTitle>{{ values.title }}</fudis-heading>
  <fudis-dialog-content [contentFocus]="true">
    @if (values.message) {
      <fudis-body-text>{{ values.message }}</fudis-body-text>
    }
    <sis-technical-message-view [title]="'COMMON.SHOW_ERROR_DETAILS' | translate" [message]="errorInfo" />
  </fudis-dialog-content>
  <fudis-dialog-actions>
    <fudis-button [variant]="'secondary'" [label]="'COMMON.REFRESH_PAGE' | translate" (handleClick)="refreshPage()" />
    <fudis-button fudisDialogClose [label]="'COMMON.CLOSE_ERROR' | translate" />
  </fudis-dialog-actions>
</fudis-dialog>
